/**
 * Pure helpers for trainer → member invite / resend flows.
 * @see _bmad-output/add-member-requirements.md
 */

export type ExistingRelationshipInviteAction =
  | { action: 'resend'; bumpRequestedAt: true }
  | { action: 'already_connected' }
  | { action: 'reopen' }
  | { action: 'blocked'; message: string };

export function existingRelationshipInviteAction(status: string): ExistingRelationshipInviteAction {
  if (status === 'active') {
    return { action: 'already_connected' };
  }
  if (status === 'pending' || status === 'onboarding') {
    return { action: 'resend', bumpRequestedAt: true };
  }
  if (status === 'inactive' || status === 'rejected') {
    return { action: 'reopen' };
  }
  const label = status === 'paused' ? 'paused' : status === 'terminated' ? 'terminated' : status;
  return {
    action: 'blocked',
    message: `Cannot send an invitation while this connection is ${label}.`,
  };
}

/** Default: attempt send in production; set REACT_APP_SEND_INVITE_EMAIL=false to disable locally. */
export function shouldAttemptInviteEmail(): boolean {
  return process.env.REACT_APP_SEND_INVITE_EMAIL !== 'false';
}

/**
 * Base URL for links in invite / invite-accepted emails.
 * Same as connection-invite: browser origin when available (so localhost stays localhost).
 */
export function resolveInviteEmailAppUrl(explicit?: string | null): string | undefined {
  const trimmed = explicit?.trim();
  if (trimmed) return trimmed.replace(/\/$/, '');
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin.replace(/\/$/, '');
  }
  const fromEnv = process.env.REACT_APP_SITE_URL?.trim().replace(/\/$/, '');
  return fromEnv || undefined;
}
